import apiClient from './apiClient';

export const casesAPI = {
  list: (params) => apiClient.get('/cases/cases/', { params }),
  get: (id) => apiClient.get(`/cases/cases/${id}/`),
  create: (data) => apiClient.post('/cases/cases/', data),
  update: (id, data) => apiClient.put(`/cases/cases/${id}/`, data),
  delete: (id) => apiClient.delete(`/cases/cases/${id}/`),
  getAvailableStages: (id) => apiClient.get(`/cases/cases/${id}/available_stages/`),
  getAvailableTransitions: (id) => apiClient.get(`/cases/cases/${id}/available_transitions/`),
  getStageHistory: (id) => apiClient.get(`/cases/cases/${id}/stage_history/`),
  changeStage: (id, stageId, comment) => apiClient.post(`/cases/cases/${id}/change_stage/`, { stage_id: stageId, comment }),
};

export const caseEventsAPI = {
  list: (params) => apiClient.get('/cases/events/', { params }),
  create: (data) => apiClient.post('/cases/events/', data),
  update: (id, data) => apiClient.put(`/cases/events/${id}/`, data),
  delete: (id) => apiClient.delete(`/cases/events/${id}/`),
};

export const caseCommentsAPI = {
  list: (params) => apiClient.get('/cases/comments/', { params }),
  create: (data) => apiClient.post('/cases/comments/', data),
  delete: (id) => apiClient.delete(`/cases/comments/${id}/`),
};

export const caseTasksAPI = {
  list: (params) => apiClient.get('/cases/tasks/', { params }),
  create: (data) => apiClient.post('/cases/tasks/', data),
  update: (id, data) => apiClient.patch(`/cases/tasks/${id}/`, data),
  delete: (id) => apiClient.delete(`/cases/tasks/${id}/`),
};

export const caseActivityAPI = {
  list: (params) => apiClient.get('/cases/activity/', { params }),
};
